import { fromJS, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
} from '../../../utils/helpers/model.helper';

export const TOTAL_PER_MONTH_FILTER_SCHEMA = Object.freeze({
  MONTH: 0,
  YEAR: 0, // calendar year (not tax year)
  DURATION: 0,
});
const RECORD = generateSchema(TOTAL_PER_MONTH_FILTER_SCHEMA);
const KEYS: any = generateKeys(TOTAL_PER_MONTH_FILTER_SCHEMA);

export class TotalPerMonthFilter extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get month(): number {
    return this.get(KEYS.MONTH);
  }

  get duration(): number {
    return this.get(KEYS.DURATION);
  }

  get year(): number {
    return this.get(KEYS.YEAR);
  }
}
